import React from "react";
import Style from './Support.module.css'
import SupportListTabel from "./SupportListTabel";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";

function Poshtibani() {
  let history = useHistory();

  return (
    <section className={Style.pageHolder}>
      <MenuTitle title="پشتیبانی" />
      <div className={Style.imageHolder}><img src="/Assets/Images/support/supportSvg.svg" alt="" /></div>
      <button className={Style.newChatBtn} onClick={()=>history.push("/newmessage")}>ایجاد پیام جدید +</button>
      <SupportListTabel/>
    </section>
  );
}
export default Poshtibani;
